import {
    FETCH_ORG_SURVEY_ANSWERS_SUCCESS,
    ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS,
    SHOW_ORG_SURVEY_ANSWERS_MESSAGE,
    SHOW_ORG_SURVEY_ANSWERS_LOADER,
    HIDE_ORG_SURVEY_ANSWERS_LOADER,
    HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE,
    CLEAR_SESSION,
} from 'constants/ActionTypes';

const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    orgSurveyAnswers: {},
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case FETCH_ORG_SURVEY_ANSWERS_SUCCESS: {
            return {
                ...state,
                loader: false,
                orgSurveyAnswers: action.payload,
            };
        }
        case ON_SAVE_ORG_SURVEY_ANSWERS_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Org Survey Answers Updated Successfully',
                showMessage: true,
                orgSurveyAnswers: action.payload,
                loader: false,
            };
        }
        case SHOW_ORG_SURVEY_ANSWERS_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case SHOW_ORG_SURVEY_ANSWERS_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_ORG_SURVEY_ANSWERS_LOADER: {
            return { ...state, loader: false };
        }
        case HANDLE_ORG_SURVEY_ANSWER_MESSAGE_CLOSE: {
            return { ...state, showMessage: false };
        }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/OrgSurveyAnswer.js